<template>
  <gjw-dialog
    class="progress-dialog"
    :show-dialog="dialogVisible"
    :config="{ showFooter: false, width: '300px' }">
    <div class="progress-container">
      <span>{{ label }}</span>
      <el-progress :percentage="percentage" :stroke-width="10" :show-text="false"></el-progress>
    </div>
  </gjw-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { localCachePath, checkExistFile } from '@/core/desktopCache'

export default {
  name: 'PlaceholderTabContent',
  data() {
    return {
      dialogVisible: false,
      saveAsPath: '',
      percentage: 0,
      resourceInfo: null,
      disabledPlace: true,
      progressStatus: null,
      successNumber: 0,
      errorNumber: 0,
      subdivideType: '',
      familyFoundStrategy: '',
      batchDownloadStatus: false,
      batchSuccess: false,
      batchData: [],
      versionResourceInfo: null,
    }
  },
  props: {
    resourceType: {
      type: String,
      default: 'COMPONENT'
    },
    label: {
      type: String,
      default() {
        return this.$t ? this.$t('load.loadProgressDialogLoading') : '正在载入'
      }
    },
    increment: {
      type: Number,
      default: 10
    },
    selectedList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters({
      softwareCode: 'softwareCode',
      softwareVersion: 'softwareVersion',
      user: 'user/user'
    }),
  },
  methods: {
    mergeArraysById(array1, array2) {
      const mergedMap = new Map()
      array1.forEach((item) => {
        mergedMap.set(item.id, { ...item })
      })
      array2.forEach((item) => {
        if (mergedMap.has(item.id)) {
          mergedMap.set(item.id, { ...item, ...mergedMap.get(item.id) })
        }
      })
      return Array.from(mergedMap.values())
    },
    init(subdivideType) {
      this.dialogVisible = true
      this.successNumber = 0
      this.errorNumber = 0
      this.percentage = 0
      this.subdivideType = subdivideType
    },
    async openDialog(row, subdivideType, familyFoundStrategy) {
      this.init(subdivideType)
      this.resourceInfo = row
      this.familyFoundStrategy = familyFoundStrategy
      const params = { publicComponentId: row.publicComponentId, softwareCode: this.softwareCode }
      const res = await this.$api.components.list(params)
      this.versionResourceInfo = res.list ? res.list[0] : null
      await this.download()
    },
    async batchOpenDialog(subdivideType, data, batchSelectinData) {
      this.init(subdivideType)
      this.batchData = this.mergeArraysById(data, batchSelectinData)
      if (!this.batchSuccess) {
        for (let i = 0; i < this.batchData.length; i++) {
          const item = this.batchData[i]
          let downloadUrl
          if (['bimmake'].includes(this.softwareCode)) {
            downloadUrl = await this.$api.download.generalDownloadUrl(item.publicComponentId, { software_code: this.softwareCode, software_version: this.softwareVersion })
          } else {
            downloadUrl = await this.$api.download.novaDownloadUrl(this.softwareCode, item.publicComponentId, { software_version: this.softwareVersion })
          }
          await this.download(downloadUrl, item)
        }
        // console.log('END')
        this.batchSuccess = true
      }
    },
    beforeDownload(row) {
      const catchPath = localCachePath()
      const type = this.resourceType === 'COMPONENT' ? '' : `${this.resourceType}_`
      this.saveAsPath = `${catchPath}\\${type}${this.versionResourceInfo.dataVersionId || row.dataVersionId}`
      console.log('下载资源前获取插件下载地址, 保存路径：', this.saveAsPath)
      return checkExistFile(this.saveAsPath)
    },
    async download(url, row) {
      try {
        if (this.subdivideType === 'single' && await this.beforeDownload(row)) {
          console.log('本地有缓存，跳过下载，精度条100')
          this.percentage = 100
          this.disabledPlace = false
          this.progressStatus = 'success'
          if (this.resourceType === 'COMPONENT') {
            this.onComponentLoad()
          } else if (this.resourceType === 'MODULE') {
            this.onModuleLoad()
          }
          return
        }
        if (this.subdivideType === 'single') {
          let downloadUrl
          if (['bimmake'].includes(this.softwareCode)) {
            downloadUrl = await this.$api.download.generalDownloadUrl(this.resourceInfo.publicComponentId, { software_code: this.softwareCode, software_version: this.softwareVersion })
          } else {
            downloadUrl = await this.$api.download.novaDownloadUrl(this.softwareCode, this.resourceInfo.publicComponentId, { software_version: this.softwareVersion })
          }
          await this.downloadFile(downloadUrl)
        } else if (this.subdivideType === 'batch') {
          await this.downloadFile(url, row)
        }
      } catch (err) {
        this.errorNumber += 1
        this.progressStatus = 'exception'
        this.taskComplete()
      }
    },
    async downloadFile(downloadUrl, row) {
      if (downloadUrl) {
        try {
          const catchPath = localCachePath()
          const type = this.resourceType === 'COMPONENT' ? '' : `${this.resourceType}_`
          const saveAsPath = row ? `${catchPath}\\${type}${row.dataVersionId}` : this.saveAsPath
          await this.$desktopClient.DownloadFile(downloadUrl, saveAsPath, true)
          if (this.subdivideType === 'single') {
            this.percentage = 100
          }
          this.disabledPlace = false
          this.progressStatus = 'success'
          this.$tracks({
            event: 'downloadSpaceComponent',
            params: {
              g_c_file_id: this.resourceInfo?.publicComponentId || row.publicComponentId,
            }
          })
          if (this.resourceType === 'COMPONENT') {
            await this.onComponentLoad(row)
          }
        } catch (err) {
          console.error(err)
          this.errorNumber += 1
          this.progressStatus = 'exception'
          this.taskComplete()
        }
      } else {
        this.errorNumber += 1
        this.progressStatus = 'exception'
        this.taskComplete()
      }
    },
    tooltipMessageBox() {
      if (this.subdivideType === 'single') {
        if (this.successNumber > 0) {
          this.$message.success(this.$t('load.loadProgressDialogLoadSuccess'))
        } else {
          this.$message.error(this.$t('load.loadProgressDialogLoadFailed'))
        }
        return
      }
      let message = ''
      let type
      if (this.successNumber > 0) {
        message += `<div>${this.successNumber}${this.$t('load.loadProgressDialogBatchSuccess')}</div>`
      }
      if (this.errorNumber > 0) {
        message += `<div>${this.errorNumber}${this.$t('load.loadProgressDialogBatchFailed')}</div>`
      }

      if (this.successNumber > 0 && this.errorNumber === 0) {
        type = 'success'
      } else if (this.successNumber === 0 && this.errorNumber > 0) {
        type = 'error'
      } else {
        type = 'info'
      }

      this.$confirm(
        `<div>${message}</div>`,
        {
          confirmButtonText: this.$t('common.confirm'),
          showClose: false,
          showCancelButton: false,
          type,
          dangerouslyUseHTMLString: true
        }
      )
        .then(() => {
          this.batchDownloadStatus = false
          this.batchSuccess = false
          this.$emit('clearSelection')
        })
        .catch(() => {
          this.dialogVisible = false
          this.batchDownloadStatus = false
          this.batchSuccess = false
          this.$emit('clearSelection')
        })
    },
    taskComplete() {
      if (this.subdivideType === 'single' || this.successNumber + this.errorNumber === this.batchData.length) {
        if (this.successNumber > 0 || this.errorNumber > 0) {
          this.tooltipMessageBox()
        }
      }
    },
    async loadComponent(params) {
      try {
        const res = await this.$desktopClient.LoadComponent(params)
        if (res.code === 'success' && res.data) {
          this.successNumber += 1
          this.percentage < 95 && (this.percentage += 5)
        } else {
          this.errorNumber += 1
          this.progressStatus = 'exception'
        }
        this.taskComplete()
        if (this.successNumber + this.errorNumber === this.batchData.length) {
          this.percentage = 100
          this.dialogVisible = false
        }
      } finally {
        this.subdivideType === 'single' && (this.dialogVisible = false)
      }
    },
    async onComponentLoad(row) {
      if (this.subdivideType === 'single') { // 单个载入
        this.$tracks({
          event: 'loadSpaceComponent',
          params: {
            g_c_file_id: this.resourceInfo.publicComponentId,
            g_c_fimaliy_type: this.radio
          }
        })
        const params = {
          userId: this.user.strId,
          softwareVersionId: this.resourceInfo.id,
          dataVersionId: this.resourceInfo.dataVersionId,
          name: this.resourceInfo.name,
          suffix: this.resourceInfo.suffix,
          filePath: this.saveAsPath,
          familyId: this.resourceInfo.familyId,
          familyFoundStrategy: this.familyFoundStrategy || 'FFS_OVERWRITE'
        }
        await this.loadComponent(params)
      } else if (this.subdivideType === 'batch') {
        const catchPath = localCachePath() // 批量载入
        const params = {
          userId: this.user.strId,
          softwareVersionId: row.softwareVersionId,
          dataVersionId: row.dataVersionId,
          name: row.name,
          suffix: row.suffix,
          filePath: `${catchPath}\\${row.dataVersionId}`,
          familyId: row.familyId,
          familyFoundStrategy: row.reName === true ? 'FFS_CREATE' : 'FFS_OVERWRITE' || 'FFS_OVERWRITE'
        }
        await this.loadComponent(params)
      }
    },
  }
}
</script>

<style lang="less" scoped>
.progress-dialog {
  .progress-container {
    display: flex;
    align-items: baseline;
    span {
      padding-right: 10px;
    }
    .el-progress {
      flex: 1
    }
  }
  /deep/ .el-dialog__header {
    display: none;
  }
}
</style>
